import Axios from "axios";
import {
    SET_PROJECT_BUDGET_LIST,
    UNSET_PROJECT_BUDGET_LIST,
  } from "@/store/mutation-types";
import { getProjectBudgetList } from "@/store/api";

// initial state
const state = {
  getProjectBudgetList: [],
};

const getters = {
  getProjectBudgetList(state) {
    return state.getProjectBudgetList;
  },
};

const mutations = {
  [SET_PROJECT_BUDGET_LIST](state, data) {
    state.getProjectBudgetList = data;
  },
  [UNSET_PROJECT_BUDGET_LIST](state) {
    state.getProjectBudgetList = [];
  },
};

const actions = {
  getProjectBudgetList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProjectBudgetList, data)
        .then(function (response) {
          commit('SET_PROJECT_BUDGET_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PROJECT_BUDGET_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  saveUpdateProjectBudget({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post('project/save-update-project-budget', data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};